import Vue from "vue";
import dateFormats, { DEFAULT_DATETIME_FORMAT_MILLISECONDS } from "@/static/dateFormats";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

export const filterFormatDateTimeMilliseconds = (value: string | Date): string => {
  if (!value) return "";
  return dayjs(value, dateFormats, false).format(DEFAULT_DATETIME_FORMAT_MILLISECONDS);
};

Vue.filter("formatDateTimeMilliseconds", filterFormatDateTimeMilliseconds);
